module.exports = "/packs/images/support/support-page-banner-2ed424ffb263fdab54f5b373a442ae1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/support/support-page-banner.jpg
// module id = 1824
// module chunks = 0